// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__ekK2h","radioButtionLabel":"Radio_radioButtionLabel__0hHdc","radioButton":"Radio_radioButton__dOfRz"};